/* src/app/modules/portal/components/system-overview-default/system-overview-default.component.scss */
/*# sourceMappingURL=system-overview-default.component.css.map */
